import React, { useEffect } from "react";
import GroupSupportNeedsComponent from "../../../components/applicationComponents/legacy/groupSupportNeeds/GroupSupportNeedsComponent";
import { useApplicationContext } from "../../../components/applicationComponents/context/applicationContext";

export default function GroupSupportNeedsPage() {
  const { setHeaderText } = useApplicationContext();
  useEffect(() => {
    setHeaderText({
      value: "Edit Group Support Needs",
      icon: "view-app-icon icon-spec mr-3 mt-0",
    });
  }, []);

  return (
    <>
      <div className="flex flex-col align-items-start w-full height-calc">
        <GroupSupportNeedsComponent disabled={false} />
      </div>
    </>
  );
}
